import React, { useEffect, useMemo, useState } from 'react';
import { useLocation } from 'react-router-dom';
import TableComponent from 'app/components/TableComponent';
import './styles/detalles.css';
import { FormControl, InputGroup, Modal } from 'react-bootstrap-v5';
import { KTSVG } from '_metronic/helpers';
import { formatDecimal, toaster } from 'app/utilities/commons';
import * as Yup from 'yup';
import { useSelector } from 'react-redux';
import { RootState } from 'setup';
import { decodeToken } from 'app/utilities/decodeJWTToken';
import {
  getAllCollaboratorCommission,
  getCollaboratorCommissionNameAndNumber,
  getCollaboratorCommissionNumber,
  updateCollaboratorCommission,
  putRequestOpening,
  putOpeningAuthorization,
} from 'app/service/comisiones/detalleComisiones';
import axios from 'axios';
import { useFormik } from 'formik';
import { CollaboratorCommissionAllResponse } from 'app/types/comisiones';
import { invalidChar } from 'app/utilities/invalidChar';
import Swal from 'sweetalert2';
const API_URL = process.env.REACT_APP_API_NET;

type CollaboratorCommission = {
  commissionsId: number;
  periodId: number;
  collaboratorId: number;
  employeId: number;
  commissionAmount: number;
  employeeNumber: string;
  employeeName: string;
  department: string;
  job: string;
  finalCommissionAmount: number;
  approvedBy: string;
  updatedBy: number;
  requestedBy: string;
  approvedDate?: string;
  requestedDate?: string;
  createDate?: string;
};

type InputFields = {
  name: JSX.Element;
  number: JSX.Element;
};

const CollaboratorCommissionSchema = Yup.object().shape({
  finalCommissionAmount: Yup.number()
    .required('Este campo es requerido.')
    .min(0, 'El monto debe ser igual o mayor a 0')
    .max(999999, 'El monto no puede ser mayor a 999,999'),
});

const heads = [
  { code: 'employeeNumber', label: 'No. Empleado' },
  { code: 'employeeName', label: 'Nombre' },
  { code: 'department', label: 'Departamento' },
  { code: 'job', label: 'Puesto' },
  { code: 'finalCommissionAmount', label: 'Comisiones' },
  { code: 'requestedBy', label: 'Revisa' },
  { code: 'approvedBy', label: 'Autoriza' },
];

const filterOptions = [
  { id: '1', fecha: 'Nombre', field: 'name' },
  { id: '2', fecha: 'Número de Empleado', field: 'number' },
];

const Detview: React.FC = () => {
  const location = useLocation<any>();
  const [periodId, setPeriodId] = useState<any>(location.state?.periodId);
  const [show, setShow] = useState(false);
  const [showFilterModal, setShowFilterModal] = useState(false);

  const [employeeName, setEmployeeName] = useState('');
  const [employeeNumber, setEmployeeNumber] = useState('');
  const [selectedOption, setSelectedOption] = useState('');
  const [selectedName, setSelectedName] = useState<string>('');
  const [selectedCommission, setSelectedCommission] = useState<string>('');
  const [id, setId] = useState<any>();

  const [collaboratorComission, setCollaboratorComission] = useState<
    CollaboratorCommission[]
  >([]);
  const [loadingGrid, setLoadingGrid] = useState<boolean>(true);
  const [loadingInfo, setLoadingInfo] = useState(false);
  const [totalRecords, setTotalRecords] = useState(0);

  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(5);
  const [isFiltered, setIsFiltered] = useState<boolean>(false);

  //Get userId
  const accessToken: any = useSelector<RootState>(
    (state) => state.auth.accessToken
  );
  const token: any = decodeToken(accessToken);

  const roles = JSON.parse(token?.RoleForDeparment ?? []);

  const [createdDate, setCreatedDate] = useState<any>();
  const [requestedDate, setRequestedDate] = useState<any>();
  const [authorizationDate, setAuthorizationDate] = useState<any>();
  const [canSeeAperturaButtons, setCanSeeAperturaButtons] = useState(false);

  useEffect(() => {
    const fetchUserRoles = async () => {
      try {
        const res = await axios.get(`${API_URL}User/${token.nameid}`);
        const userRoles: any[] = res.data.data.roles || [];
        const hasAllowedRole = userRoles.some(
          (r: any) => r.userRole?.code === 'ADMIN' || r.userRole?.code === 'ADMC'
        );
        setCanSeeAperturaButtons(hasAllowedRole);
      } catch (err) {
        console.error('Error fetching user roles:', err);
      }
    };
    fetchUserRoles();
  }, []);

  const fetchPeriods = async () => {
    try {
      const res = await axios.get(`${API_URL}Period`);
      const filteredPeriod = res.data.data.records.filter(
        (record: { statusId: number }) => record.statusId === 1
      );
      if (filteredPeriod.length > 0) {
        setPeriodId(filteredPeriod[0].id);
      }
    } catch (err) {
      console.error('Error al obtener los periodos:', err);
    }
  };

  useEffect(() => {
    if (!periodId) {
      fetchPeriods();
    }
  }, [periodId]);

  const handleRequestOpening = async () => {
    try {
      await putRequestOpening(token.nameid, periodId);
      toaster.success('Apertura de Revisión realizada con éxito');
      fetchCollaboratorComission();
    } catch (err: any) {
      console.error('Error on Request Opening:', err);
      toaster.error(err.message ?? 'Hubo un error al realizar la apertura de revisión');
    }
  };

  const handleOpeningAuthorization = async () => {
    try {
      await putOpeningAuthorization(token.nameid, periodId);
      toaster.success('Apertura de Autorización realizada con éxito');
      fetchCollaboratorComission();
    } catch (err: any) {
      console.error('Error on Opening Authorization:', err);
      toaster.error(err.message ?? 'Hubo un error al realizar la apertura de autorización');
    }
  };

  const fetchCollaboratorComission = async () => {
    try {
      const res = await getAllCollaboratorCommission(
        token.nameid,
        currentPage,
        pageSize
      );
      setCollaboratorComission(
        res!.records.map((record) => ({
          ...record,
        }))
      );

      setCreatedDate(res!.records[0].createDate?.split('T')[0]);
      setRequestedDate(res!.records[0].requestedDate?.split('T')[0]);
      setAuthorizationDate(res!.records[0].approvedDate?.split('T')[0]);

      setLoadingInfo(!loadingInfo);
      setTotalRecords(res!.totalRecords);
      setLoadingGrid(false);
    } catch (err) {
      console.error('Error fetching Collaborator Comission', err);
    }
  };

  useEffect(() => {
    if (isFiltered) {
      if (selectedOption === '1' && employeeName) {
        fetchCollaboratorCommissionFilter(employeeName);
      } else if (selectedOption === '2' && employeeNumber) {
        fetchCollaboratorCommissionFilterNumber(employeeNumber);
      }
    } else {
      fetchCollaboratorComission();
    }
  }, [currentPage, pageSize, isFiltered]);

  const formCollaboratorComission = useFormik<any>({
    validationSchema: CollaboratorCommissionSchema,
    initialValues: {
      finalCommissionAmount: 0,
    },
    onSubmit: async (values, { setSubmitting }) => {
      try {
        await updateCollaboratorCommission(
          id,
          values.finalCommissionAmount,
          token.nameid
        );
        toaster.success('Se cambio con éxito la información');
        handleClose();
        fetchCollaboratorComission();
      } catch (err) {
        console.error('Error', err);
      } finally {
        setSubmitting(false);
      }
    },
  });

  const getCollaboratorCommissionsId = async (
    idUsuario: number,
    commissionId: number
  ) => {
    try {
      const response = await axios.get(
        `${API_URL}CollaboratorCommissions/GetByCommissionId?UserId=${idUsuario}&CommissionId=${commissionId}`
      );
      formCollaboratorComission.setValues({
        finalCommissionAmount: response.data.data.finalCommissionAmount || 0,
      });
      setSelectedCommission(response.data.data.finalCommissionAmount);
      setSelectedName(response.data.data.employeeName);
      setId(response.data.data.commissionsId);
    } catch (error) {
      console.error('Error loading the info');
      throw error;
    }
  };

  const fetchCollaboratorCommissionFilter = async (employeeName?: string) => {
    setIsFiltered(true);
    try {
      const res = await getCollaboratorCommissionNameAndNumber(
        token.nameid,
        currentPage,
        pageSize,
        employeeName
      );
      setCollaboratorComission(
        res.records.map((record: any) => ({
          ...record,
        }))
      );
      setTotalRecords(res.totalRecords);
      setLoadingGrid(false);
    } catch (err) {
      console.error(
        'Error al obtener los NAME Collaborator commission filters'
      );
    }
  };

  const fetchCollaboratorCommissionFilterNumber = async (
    employeeNumber?: string
  ) => {
    setIsFiltered(true);
    try {
      const response = await axios.get<CollaboratorCommissionAllResponse>(
        `${API_URL}CollaboratorCommissions/GetByEmployeeNumber?UserId=${token.nameid}&EmployeeNumber=${employeeNumber}&Page=${currentPage}&PageSize=${pageSize}`
      );
      const res = response.data.data;

      setCollaboratorComission(
        res.records.map((record) => ({
          ...record,
        }))
      );
      setTotalRecords(res.totalRecords);
      setLoadingGrid(false);
    } catch (err) {
      console.warn(
        'Error al obtener los NUMBER Collaborator commission filters',
        err
      );
    }
  };
  const rows = useMemo(() => {
    if (!loadingGrid && collaboratorComission.length) {
      return collaboratorComission.map((row) => ({
        employeeNumber: (
          <div style={{ textAlign: 'center', cursor: 'pointer' }}>
            {row.employeeNumber}
          </div>
        ),
        employeeName: (
          <div style={{ textAlign: 'center' }}>{row.employeeName}</div>
        ),
        department: <div style={{ textAlign: 'center' }}>{row.department}</div>,
        job: <div style={{ textAlign: 'center' }}>{row.job}</div>,
        finalCommissionAmount: (
          <div
            style={{ textAlign: 'center', cursor: 'pointer' }}
            className="text-info"
            onClick={() => {
              if (roles?.isRequest) {
                if (!isRequestBtnDisabled) {
                  handleShow();
                  getCollaboratorCommissionsId(token.nameid, row.commissionsId);
                } else {
                  toaster.warning('No se puede modificar la información, ya fueron cerradas las comisiones.');
                }
              }

              if (roles?.isAuth) {
                if (!isAuthorizeBtnDisabled) {
                  handleShow();
                  getCollaboratorCommissionsId(token.nameid, row.commissionsId);
                } else {
                  if (requestedDate === undefined) {
                    toaster.warning("No se puede modificar la información, aún no han revisado las comisiones")
                  } else {
                    toaster.warning('No se puede modificar la información, ya fueron cerradas las comisiones.');
                  }
                }
              }

            }}
          >
            ${formatDecimal.format(row.finalCommissionAmount)}
          </div>
        ),
        requestedBy: (
          <div style={{ textAlign: 'center' }}>
            {row.requestedBy.trim() || 'N/A'}
          </div>
        ),
        approvedBy: (
          <div style={{ textAlign: 'center' }}>
            {row.approvedBy.trim() || 'N/A'}
          </div>
        ),
      }));
    }
    return [];
  }, [collaboratorComission, loadingGrid]);

  const isAuthorizeBtnDisabled = useMemo(() => {
    return collaboratorComission.length === 0 || collaboratorComission.some(
      (record) => record.approvedBy.trim() || !record.requestedBy.trim()
    );
  }, [collaboratorComission]);

  const isRequestBtnDisabled = useMemo(() => {
    return collaboratorComission.length === 0 || collaboratorComission.some((record) => record.requestedBy.trim());
  }, [collaboratorComission]);

  const handleShow = () => {
    setShow(true);
  };

  const handleClose = () => {
    setShow(false);
  };

  const handleFilterOpen = () => {
    setShowFilterModal(true);
  };

  const handleFilterClose = () => {
    setShowFilterModal(false);
  };

  const handleSelectChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
    setSelectedOption(e.target.value);
  };

  const handleSearch = () => {
    if (selectedOption === '1' && employeeName) {
      setIsFiltered(true);
      setCurrentPage(1);
      fetchCollaboratorCommissionFilter(employeeName);
    } else if (selectedOption === '2' && employeeNumber) {
      setIsFiltered(true);
      setCurrentPage(1);
      fetchCollaboratorCommissionFilterNumber(employeeNumber);
    }
  };

  const inputFields: InputFields = {
    name: (
      <>
        <div className="mt-4">
          <label className="form-label fw-bold">Nombre: </label>
        </div>
        <div>
          <input
            type="text"
            value={employeeName}
            className="form-control mt-4"
            onChange={(e) => setEmployeeName(e.target.value)}
          />
          <div className="mt-4 d-flex flex-row-reverse">
            <button
              type="submit"
              className="btn btn-primary"
              data-kt-menu-dismiss="true"
              onClick={(e) => {
                e.preventDefault();
                handleSearch();
                handleFilterClose();
              }}
            >
              Buscar
            </button>
            <button
              type="reset"
              className="btn btn-white btn-active-light-primary me-2"
              data-kt-menu-dismiss="true"
              onClick={(e) => {
                e.preventDefault();
                handleFilterClose();
                handleClearFilters();
              }}
            >
              Limpiar
            </button>
          </div>
        </div>
      </>
    ),
    number: (
      <>
        <div className="mt-4">
          <label className="form-label fw-bold">Número de Empleado: </label>
        </div>
        <div>
          <input
            type="text"
            value={employeeNumber}
            className="form-control mt-4"
            onChange={(e) => setEmployeeNumber(e.target.value)}
          />
          <div className="mt-4 d-flex flex-row-reverse">
            <button
              type="submit"
              className="btn btn-primary"
              data-kt-menu-dismiss="true"
              onClick={(e) => {
                e.preventDefault();
                handleSearch();
                handleFilterClose();
              }}
            >
              Buscar
            </button>
            <button
              type="reset"
              className="btn btn-white btn-active-light-primary me-2"
              data-kt-menu-dismiss="true"
              onClick={(e) => {
                e.preventDefault();
                handleFilterClose();
                handleClearFilters();
              }}
            >
              Limpiar
            </button>
          </div>
        </div>
      </>
    ),
  };

  const fieldToShow = filterOptions.find(
    (option) => option.id === selectedOption
  )?.field;

  const authorization = async (idUser: number, isRequest: boolean) => {
    try {
      const res = await axios.put(
        `${API_URL}CollaboratorCommissions/UpdateRequestOrAuthorization?Id_user=${idUser}&IsRequest=${isRequest}`
      );
      fetchCollaboratorComission();
      toaster.success(res.data.data.mensaje);
    } catch (err) {
      console.error('Error requesting authorization: ', err);
    }
  };

  const requestAuthorization = async (idUser: number, isRequest: boolean) => {
    try {
      const res = await axios.put(
        `${API_URL}CollaboratorCommissions/UpdateRequestOrAuthorization?Id_user=${idUser}&IsRequest=${isRequest}`
      );
      fetchCollaboratorComission();
      toaster.success(res.data.data.mensaje);
    } catch (err) {
      console.error('Error requesting authorization: ', err);
    }
  };

  /**
 * Clean all the filters, inputs and fetch again the data
 */
  const handleClearFilters = () => {
    setEmployeeNumber('');
    setEmployeeName('');
    setSelectedOption('');
    setIsFiltered(false);
    setCurrentPage(1);
    fetchCollaboratorComission();
  }

  return (
    <div className="row gy-5 g-xl-8">
      <div className="col-xxl-12 col-xl-12 col-md-12 col-lg-12">
        <div className="card card-flush p-5">
          <div className="d-flex justify-content-between align-items-center mb-4">
            <div className="d-flex">
              <div className="me-3">
                <label className="form-label">Apertura de comisión</label>
                <input
                  type="text"
                  className="form-control"
                  value={createdDate || 'N/A'}
                  disabled
                />
              </div>
              <div className="me-3">
                <label className="form-label">Cierre de revisión</label>
                <input
                  type="text"
                  className="form-control"
                  value={requestedDate || 'N/A'}
                  disabled
                />
              </div>
              <div className="me-3">
                <label className="form-label">Cierre de autorización</label>
                <input
                  type="text"
                  className="form-control"
                  value={authorizationDate || 'N/A'}
                  disabled
                />
              </div>
            </div>

            <div className="d-flex align-items-center align-self-end">
              <button
                className="btn btn-light-primary border-btn w-10"
                onClick={handleFilterOpen}
              >
                <KTSVG
                  path="/media/icons/duotune/general/gen021.svg"
                  className="svg-icon svg-icon-5 svg-icon-gray-500"
                />
                <span className="ms-2">Filtrar</span>
              </button>
            </div>
          </div>

          <div className="tablee-container">
            <TableComponent
              heads={heads}
              rows={rows}
              rowsPerPage={pageSize}
              page={currentPage}
              totalRows={totalRecords}
              setPage={setCurrentPage}
            />
          </div>
          <div className="d-flex justify-content-between">
            <div>
              {canSeeAperturaButtons && requestedDate && !authorizationDate && (
                <button
                  type="button"
                  className="btn btn-primary"
                  onClick={handleRequestOpening}
                >
                  Apertura de Revisión
                </button>
              )}
              {canSeeAperturaButtons && authorizationDate && (
                <button
                  type="button"
                  className="btn btn-primary"
                  onClick={handleOpeningAuthorization}
                >
                  Apertura de Autorización
                </button>
              )}
            </div>
            <div>
              {/* Una vez que se manda la info desactivar el boton una vez que ya tiene informacion */}
              {/* SECCION AUTH COMISIONES */}
              {roles?.isAuth && (
                <button
                  type="submit"
                  className="btn btn-primary me-4"
                  disabled={isAuthorizeBtnDisabled}
                  onClick={(e) => {
                    e.preventDefault();
                    authorization(token.nameid, false);
                  }}
                >
                  Autorizar
                </button>
              )}
              {roles?.isRequest && (
                <button
                  type="submit"
                  disabled={isRequestBtnDisabled}
                  className="btn btn-primary"
                  onClick={(e) => {
                    e.preventDefault();
                    Swal.fire({
                      title: '¿Desea solicitar autorización?',
                      text: 'Una vez solicitada la autorización ya no se podrá modificar ningún dato de estas comisiones.',
                      icon: 'question',
                      showCancelButton: true,
                      padding: '2em',
                      cancelButtonText: 'Cancelar',
                      confirmButtonText: 'Aceptar',
                      reverseButtons: true,
                      customClass: {
                        confirmButton: 'btn btn-primary',
                        cancelButton: 'btn btn-light me-3',
                      },
                    }).then((result) => {
                      if (result.isConfirmed) {
                        requestAuthorization(token.nameid, true);
                      }
                    });
                  }}
                >
                  Solicitar Autorización
                </button>
              )}
            </div>
          </div>
        </div>
      </div>

      {/* Modal para asignar bono */}
      <Modal
        id="kt_modal_create"
        tabIndex={-1}
        dialogClassName="modal-dialog"
        show={show}
        onHide={handleClose}
      >
        <div className="modal-content">
          <div className="modal-header">
            <h2 className="text-muted">Detalle de Comisiones</h2>
            <div
              className="btn btn-sm btn-icon btn-active-color-primary"
              onClick={handleClose}
            >
              <KTSVG
                className="svg-icon-2"
                path="/media/icons/duotune/arrows/arr061.svg"
              />
            </div>
          </div>

          <div className="modal-body mx-5">
            <form
              className="form needs-validation"
              noValidate
              onSubmit={formCollaboratorComission.handleSubmit}
            >
              <div className="mb-3">
                <label className="form-label">Nombre</label>
                <input
                  type="text"
                  className="form-control"
                  value={selectedName}
                  disabled
                />
              </div>
              <div className="mb-3">
                <label className="form-label" htmlFor="comision">
                  Comisiones
                </label>
                <InputGroup>
                  <InputGroup.Text>$</InputGroup.Text>
                  <FormControl
                    type="number"
                    id="comision"
                    name="finalCommissionAmount"
                    onKeyDown={invalidChar}
                    value={
                      formCollaboratorComission.values.finalCommissionAmount
                    }
                    onChange={formCollaboratorComission.handleChange}
                    placeholder="Ingrese monto"
                    required
                    isInvalid={
                      !!formCollaboratorComission.errors.finalCommissionAmount
                    }
                  />
                  {formCollaboratorComission.touched.finalCommissionAmount &&
                    formCollaboratorComission.errors.finalCommissionAmount && (
                      <div className="fv-plugins-message-container text-danger w-100">
                        <span role="alert">
                          {
                            formCollaboratorComission.errors
                              .finalCommissionAmount
                          }
                        </span>
                      </div>
                    )}
                </InputGroup>
              </div>
              <div className="d-flex justify-content-between mt-4">
                <button
                  type="button"
                  className="btn btn-secondary me-2"
                  onClick={handleClose}
                >
                  Cancelar
                </button>
                <button
                  type="submit"
                  className="btn btn-primary"
                >
                  Guardar
                </button>
              </div>
            </form>
          </div>
        </div>
      </Modal>

      <Modal
        id="kt_modal_filter"
        tabIndex={-1}
        dialogClassName="modal-dialog"
        show={showFilterModal}
        onHide={handleFilterClose}
      >
        <div className="modal-content">
          <div className="modal-header">
            <h1 className="text-muted mx-5">Filtrar Resultados</h1>
            <div
              className="btn btn-sm btn-icon btn-active-color-primary"
              onClick={handleFilterClose}
            >
              <KTSVG
                className="svg-icon-2"
                path="/media/icons/duotune/arrows/arr061.svg"
              />
            </div>
          </div>
          <div className="modal-body mx-5 padding-top-00">
            <div className="mt-4">
              <label className="form-label fw-bold">
                Seleccione una opción:
              </label>
            </div>
            <select
              className="form-select"
              value={selectedOption}
              onChange={handleSelectChange}
            >
              <option value="">Seleccione</option>
              {filterOptions.map((option) => (
                <option key={option.id} value={option.id}>
                  {option.fecha}
                </option>
              ))}
            </select>
            {fieldToShow && inputFields[fieldToShow as keyof InputFields]}
          </div>
        </div>
      </Modal>
    </div>
  );
};

export { Detview };
